import React from 'react';
import Kicker from '../ui/Kicker';

const PHASES = [
  {
    step: '01',
    title: 'Discover',
    desc: 'We map your operations, data flows and customer journeys, then find the places where intelligence actually changes the economics.',
  },
  {
    step: '02',
    title: 'Design & Prototype',
    desc: 'Sprint-based concepts become functional prototypes, tested with the people who will have to live with them.',
  },
  {
    step: '03',
    title: 'Incubate & Integrate',
    desc: 'Scalable builds wired into your existing systems, with the security, data and governance questions settled up front rather than at launch.',
  },
  {
    step: '04',
    title: 'Enable & Scale',
    desc: 'We upskill your teams, document the handover, and prepare the ground for whatever you want to build next.',
  },
];

export default function Process() {
  return (
    <section className="approach" id="process" aria-label="How we work">
      <div className="container">
        <div className="section-head reveal">
          <Kicker>How we work</Kicker>
          <h2 className="section-title">Four phases, each ending in something real</h2>
          <p className="section-sub">
            No phase closes on a document alone. Every one of them hands you something you
            can look at, use or measure.
          </p>
        </div>

        <ol className="phase-list">
          {PHASES.map((phase) => (
            <li className="phase reveal" key={phase.step}>
              <span className="phase-num">[{phase.step}]</span>
              <div>
                <h3>{phase.title}</h3>
                <p>{phase.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
